import HistoryLayout from '@/routes/account/layout/HistoryLayout';
import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

const Vouchers: FC = () => {
  return (
    <HistoryLayout bookingType="vouchers">
      <Outlet />
    </HistoryLayout>
  );
};

export default Vouchers;
